export default __webpack_public_path__ + "static/media/img--interiors-5.5ce60a49.jpg";